import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import numbersCommutativityUtils from './utils/numbersCommutativity.utils'



export default class NumbersCommutativityLevelComponent extends BaseLevel {
    onEnter = () => {
        const answerRequired = this.props.level.settings.answer_required
        let result = 0
        switch (answerRequired) {
            case '2':
            case '3':
                result = this.state.quantities.value_2
                break
            default:
                result = this.state.quantities.value_1
                break
        }
        if (+this.state.answer === +result) {
            this.setState({ wrongAnswer: false, answer: '?' })
            this.props.onRoundComplete()
            this.generateLevel()
            this.onRoundComplete()
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }
    render() {
        const level = this.props.level
        const stage = this.props.stage
        const settings = level.settings
        const quantities = this.state.quantities
        const operation = this.state.operation
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const answerRequired = settings.answer_required || 'answer'
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight

        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answer} showSum={settings.show_sum} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {gameContainerHeight > 0 && numbersCommutativityUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer)}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/numbersCommutativity.levels.js